"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSelectorItem = exports.GridSelector = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _heading = _interopRequireDefault(require("../heading"));

var _arrowIcon = _interopRequireDefault(require("../arrow-icon"));

var _index = _interopRequireDefault(require("./index.scss"));

var GridSelector = function GridSelector(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_index["default"].GridSelector, className)
  }, children);
};

exports.GridSelector = GridSelector;
GridSelector.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string
};

var GridSelectorItem = function GridSelectorItem(_ref2) {
  var _cx;

  var className = _ref2.className,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      linkUrl = _ref2.linkUrl,
      linkElement = _ref2.linkElement,
      children = _ref2.children,
      color = _ref2.color,
      uppercase = _ref2.uppercase,
      body = _ref2.body,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["className", "title", "subtitle", "linkUrl", "linkElement", "children", "color", "uppercase", "body"]);

  var Link = linkElement || function (props) {
    return _react["default"].createElement("a", (0, _extends2["default"])({}, props, {
      href: linkUrl
    }));
  };

  return _react["default"].createElement(Link, {
    className: (0, _classnames["default"])(_index["default"].GridSelectorItem, className, (_cx = {}, (0, _defineProperty2["default"])(_cx, _index["default"].seasonal, color === 'seasonal'), (0, _defineProperty2["default"])(_cx, _index["default"].black, color === 'black'), (0, _defineProperty2["default"])(_cx, _index["default"].uppercase, uppercase), _cx))
  }, _react["default"].createElement("section", null, _react["default"].createElement(_heading["default"], {
    type: "small",
    "data-test-id": props.dataTestTitle
  }, title), _react["default"].createElement(_heading["default"], {
    type: "extrasmall",
    className: _index["default"].subtitle,
    "data-test-id": props.dataTestSubtitle
  }, subtitle), body && _react["default"].createElement(_heading["default"], {
    type: "extrasmall",
    className: _index["default"].subtitle,
    "data-test-id": props.dataTestBody
  }, body)), children && _react["default"].createElement("section", {
    className: _index["default"].itemBody
  }, children), _react["default"].createElement(_arrowIcon["default"], {
    className: _index["default"].arrow
  }));
};

exports.GridSelectorItem = GridSelectorItem;
GridSelectorItem.defaultProps = {
  color: 'seasonal',
  uppercase: true
};
GridSelectorItem.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  linkUrl: _propTypes["default"].string,
  linkElement: _propTypes["default"].func,
  children: _propTypes["default"].node,
  color: (0, _propTypes.oneOf)(['black', 'seasonal']),
  uppercase: _propTypes["default"].bool,
  body: _propTypes["default"].node
};